const KeyMirror = require('keymirror');

module.exports = KeyMirror({
    UPDATE_LANGUAGE: true,
});
